function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import SideBySideTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component";
import { WORKOS_IRIS_THEME_ID } from "segments/segments-service";
import { StyledSideBySideWithBackgroundTextAndAssetComponent } from "./side-by-side-with-background-text-and-asset-component.scss";
class SideBySideWithBackgroundTextAndAssetComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledSideBySideWithBackgroundTextAndAssetComponent, {
            className: "side-by-side-with-background-text-and-asset-component",
            style: this.getStyle(),
            children: /*#__PURE__*/ _jsx("div", {
                className: "side-by-side-asset-wrapper",
                children: /*#__PURE__*/ _jsx(SideBySideTextAndAssetComponent, _object_spread({}, this.props))
            })
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getStyle", ()=>{
            const { minHeight } = this.props;
            if (!minHeight) return {};
            return {
                minHeight
            };
        });
    }
}
export { SideBySideWithBackgroundTextAndAssetComponent as default };
SideBySideWithBackgroundTextAndAssetComponent.defaultProps = _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponent.defaultProps), {
    background: {
        width: "75%",
        color: WORKOS_IRIS_THEME_ID
    },
    asset: _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponent.defaultProps.asset), {
        position: "center",
        image: _object_spread_props(_object_spread({}, SideBySideTextAndAssetComponent.defaultProps.asset.image), {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/designers-sit-together.png"
        })
    }),
    paddingTop: "0px",
    paddingBottom: "0px",
    minHeight: "650px"
});
